import { render, staticRenderFns } from "./nutritionMainpageList.vue?vue&type=template&id=55ec319e"
import script from "./nutritionMainpageList.vue?vue&type=script&lang=js"
export * from "./nutritionMainpageList.vue?vue&type=script&lang=js"
import style0 from "./nutritionMainpageList.vue?vue&type=style&index=0&id=55ec319e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports